import { render, staticRenderFns } from "./UserBlankMenu.vue?vue&type=template&id=d9829fec&scoped=true"
import script from "./UserBlankMenu.vue?vue&type=script&lang=js"
export * from "./UserBlankMenu.vue?vue&type=script&lang=js"
import style0 from "./UserBlankMenu.vue?vue&type=style&index=0&id=d9829fec&prod&lang=less&scoped=true"
import style1 from "./UserBlankMenu.vue?vue&type=style&index=1&id=d9829fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9829fec",
  null
  
)

export default component.exports